import { Button, Input, Tag } from "antd";
import dayjs from "dayjs";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { BsPersonPlus } from "react-icons/bs";
import { HiOutlineFilter } from "react-icons/hi";
import { HiPhoneArrowUpRight } from "react-icons/hi2";
import { useMediaQuery } from "react-responsive";
import { handleGetData, handleGetDataAndRows } from "../../utils/utilsApi";
import { getVNDateTime } from "../../utils/utilsFunc";
import { handleSearch } from "../../utils/utilsSearch";
import PopoverModel from "../components/modal/popoverModel";
import TableManager from "../components/table/tableManager";
const { Search } = Input;

export default function HistoryZns() {
	const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1024px)" });
	const [dataTable, setDataTable] = useState([]);
	const [dataTemplateZns, setDataTemplateZns] = useState([]);
	const [loading, setLoading] = useState(false);

	const columns = [
		{
			title: "Loại ZNS",
			dataIndex: "template_id",
			width: 150,
			render: (template_id) => {
				const template = dataTemplateZns?.find(
					(item) => item.template_id === template_id,
				);
				return template ? template.template_title : template_id;
			},
		},
		{
			title: "Tên khách hàng",
			dataIndex: "",
			width: 150,
			render: (record) => {
				return record?.template_data?.customer_name || "";
			},
		},
		{
			title: "Điện thoại",
			dataIndex: "phone",
			render: (dien_thoai) => {
				return (
					<React.Fragment>
						{dien_thoai ? (
							<a
								href={`tel:${dien_thoai}`}
								onClick={(e) => {
									e.stopPropagation();
								}}
								className="contact_cell"
							>
								<HiPhoneArrowUpRight />
								{dien_thoai}
							</a>
						) : (
							<div className="empty-text">(Trống)</div>
						)}
					</React.Fragment>
				);
			},
			width: 150,
		},
		{
			title: "Trạng thái",
			dataIndex: "zns_status",
			width: 150,
			render: (status) => {
				const s = status?.toLowerCase();

				let color = "default";
				let text = status;

				if (s === "success" || s === "thành công") {
					color = "success"; // Màu xanh lá
					text = "Thành công";
				} else if (
					s === "failed" ||
					s === "thất bại" ||
					s === "error"
				) {
					color = "error"; // Màu đỏ
					text = "Thất bại";
				}

				return (
					<Tag color={color} key={status}>
						{text.toUpperCase()}
					</Tag>
				);
			},
		},
		{
			title: "Thời gian gửi",
			dataIndex: "date_created",
			width: 180,
			render: (date_created) => {
				if (!date_created) return "";

				return dayjs(date_created).format("HH:mm:ss DD/MM/YYYY");
			},
		},
		{
			title: "Mã đặt hẹn",
			dataIndex: "",
			width: 100,
			render: (record) => {
				return record?.template_data?.booking_code;
			},
		},
	];

	// handle pagination
	const [totalRows, setTotalRows] = useState();
	const [params, setParams] = useState({
		limit: 50,
		page: 1,
	});
	const handlePaginationChange = (page, limit) => {
		setParams({
			...params,
			page,
			limit,
		});
	};

	const handleGetTemplateZns = async (q) => {
		const data = await handleGetData({
			api: "zalo_template",
			q: {
				...q,
			},
			page: params.page,
			limit: params.limit,
			setLoading,
		});
		if (data) {
			setDataTemplateZns(data.data);
		}
	};

	const handleGetDataTable = async (q) => {
		const data = await handleGetDataAndRows({
			api: "zalo_log",
			q: {
				...q,
			},
			page: params.page,
			limit: params.limit,
			setLoading,
		});
		if (data) {
			setDataTable(data.data);
			setTotalRows(data.total);
		}
	};

	useEffect(() => {
		handleGetDataTable({ ...params.q });
		handleGetTemplateZns({ ...params.q });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [params.page, params.limit]);

	const DebouncedSearch = debounce((value) => {
		handleSearch(value, params, setParams, handleGetDataTable);
	}, 500);

	return (
		<div>
			<div className="h-14 flex justify-between items-center max-lg:flex-col-reverse max-lg:h-[88px] max-lg:items-start">
				<div className="h-[48px] flex justify-start items-center gap-4">
					<Search
						placeholder="Nhập Id, tên hoặc số điện thoại"
						onChange={(e) => DebouncedSearch(e.target.value)}
						allowClear
					/>
				</div>

				<div className="h-full max-lg:h-fit py-2 flex items-center">
					<span className="text-[#186b9e] font-semibold uppercase">
						Lịch sử tin nhắn ZNS
					</span>
				</div>
			</div>

			<TableManager
				data={dataTable}
				columns={columns}
				loading={loading}
				rowKey={"_id"}
				scroll={{
					x: 1250,
					y: isTabletOrMobile
						? "calc(100vh - 248px)"
						: "calc(100vh - 220px)",
				}}
				tableProps={{
					size: "middle",
				}}
				isPage={params.page}
				isLimit={params.limit}
				totalRows={totalRows}
				handlePaginationChange={handlePaginationChange}
			/>
		</div>
	);
}
